import { css, stack } from '@bts-web/utils-style-engine';

export const modalCardStyles = css({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  width: { base: '100vw', lg: '420px' },
  height: { base: '100dvh', lg: 'auto' },
  maxHeight: { base: '100dvh', lg: '90vh' },
  background: 'screen_background.primary',
  borderRadius: { base: 0, lg: 'largeBottomRight' },
  boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.15)',
});

export const iconCircleStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '80px',
  height: '80px',
  borderRadius: '50%',
  backgroundColor: 'neutrals.fill_primary',
});

export const titleStyles = css({
  fontSize: 'headline.large_semi_bold',
  fontWeight: 'headline.large_semi_bold',
  letterSpacing: 'headline.large_semi_bold',
  lineHeight: 'headline.large_semi_bold',
  color: 'neutrals.text_primary',
  textAlign: 'center',
});

export const subtitleStyles = css({
  fontSize: 'body.medium',
  fontWeight: 'body.medium',
  letterSpacing: 'body.medium',
  lineHeight: 'body.medium',
  color: 'neutrals.text_secondary',
  textAlign: 'center',
});

export const navBarStyles = css({
  display: { base: 'none', lg: 'flex' },
});

export const centeredContentStyles = stack({
  direction: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '1',
  gap: 'small',
  marginBottom: 'extra_small',
});
